import React, { useEffect } from "react";
import { connect } from 'react-redux';
import Avatar from 'react-avatar';
import {
    Navbar,
    UncontrolledDropdown,
    // Badge,
    NavLink as RNavLink,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavItem,
    Badge,
} from "reactstrap";
import {
    Bell,
    ChevronDown,
    ExternalLink,
    Menu as MenuIcon,
    MessageSquare,
    Power,
    User,
} from "react-feather";
import swal from 'sweetalert2';
import withRouter from '../withRouter';
import { NavLink } from "react-router-dom";
import { cancelUnread, getUnread } from "../../services/notifications";
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import { countUnreadMessages } from "../../reducers/conversationsActions";

const NavbarBasic = (props) => {
    const signout = () => {
        swal.fire({
            title: "Cerrar Sesión",
            text: "Estás seguro?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: 'Cerrar Sesión',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            buttonsStyling: false,
            customClass: {
                confirmButton: "btn btn-danger ml-2",
                cancelButton: "btn btn-secondary active mr-2",
            }
        }).then(
            (value) => {
                if (value.isConfirmed) {
                    props.logout();
                    props.router.navigate('');
                }
            }
        );
    };
    useEffect(() => { 
        props.fetchUnreadMsg();
    }, [props]);

    useEffect(() => {
        const getAllUnread = async () => {
            const res_notf = await getUnread();

            if (res_notf?.success) {
                props.setUnreadNot(res_notf.unread);
            }
        };
        getAllUnread();

        return () => {
            if (cancelUnread) {
                cancelUnread();
            }
        };
    }, [props]);

    return (
        <Navbar className="header-navbar navbar-expand-lg navbar navbar-with-menu floating-nav navbar-light navbar-shadow">
            <div className="navbar-wrapper">
                <div className="navbar-container content">
                    <div className="navbar-collapse" id="navbar-mobile">
                        <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center">
                            <ul className="navbar-nav d-xl-none">
                                <NavItem className="mobile-menu mr-auto">
                                    <RNavLink
                                        className="nav-menu-main menu-toggle hidden-xs is-active"
                                        onClick={props.handleSidebarVisibility}
                                    >
                                        <MenuIcon className="ficon" />
                                    </RNavLink>
                                </NavItem>
                            </ul>
                            <ul className="nav navbar-nav bookmark-icons">
                                {props?.user?.shortcuts?.length > 0 &&
                                    <Menu menuButton={<button type="button" className="btn btn-primary ml-2 ">
                                        <span className="d-none d-md-inline">Accesos</span>
                                        <ExternalLink className="d-inline d-md-none" size={15} />
                                        <ChevronDown size={15} className="d-none d-md-inline" />
                                    </button>}>
                                        {props.user.shortcuts.map((shortcut) => (
                                            <SubMenu key={shortcut._id} label={<span className="py-1 font-weight-bold">{shortcut._id}</span>} >
                                                {shortcut.links.map((link, index) => (
                                                    <MenuItem className="font-weight-light py-1" key={`${shortcut._id}-link-${index}`} onClick={() => window.open(link.url)}>{link.name}</MenuItem>
                                                ))}
                                            </SubMenu>
                                        ))}
                                    </Menu>
                                }
                            </ul>
                        </div>
                        <ul className="nav navbar-nav float-right">
                            <li className="nav-item">
                                <NavLink to="/conversations/inbox" className="nav-link nav-link-label mr-1 position-relative bg-white" >
                                    <MessageSquare size={21} />
                                    <Badge pill color="primary" className="badge-up z-10">{props.unread_msg || null}</Badge>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/notifications" className="nav-link nav-link-label position-relative bg-white" >
                                    <Bell size={21} />
                                    <Badge pill color="primary" className="badge-up">{props.unread || null}</Badge>
                                </NavLink>
                            </li>
                            <UncontrolledDropdown
                                tag="li"
                                id="user-dropdown"
                                className="dropdown-user nav-item"
                            >
                                <DropdownToggle
                                    tag="a"
                                    data-toggle="dropdown"
                                    className="nav-link dropdown-user-link"
                                >
                                    <div className="user-nav d-sm-flex d-none">
                                        <span className="user-name text-bold-600">
                                            {props.user.name}
                                        </span>
                                        <span className="user-status">{props.user.brand}</span>
                                    </div>
                                    <span>
                                        {props?.user?.profile_pic_thumbnail ? <img
                                            src={props.user.profile_pic_thumbnail}
                                            className="round"
                                            height="40"
                                            width="40"
                                            alt="avatar"
                                        /> : <Avatar round={true} name={props.user.name} size="40" />
                                        }
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu end>
                                    <DropdownItem tag="a" href="/profile">
                                        <User size={14} className="mr-50" />
                                        <span className="align-bottom">
                                            Editar Perfil
                                        </span>
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={signout}>
                                        <Power size={14} className="mr-50" />
                                        <span>Cerrar Sesión</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </ul>
                    </div>
                </div>
            </div>
        </Navbar >
    );
};

const mapStateToProps = (state) => {
    return ({ user: state.auth.user, unread: state.notifications, unread_msg: state.conversations.unread_msg });
};

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch({ type: 'LOGOUT' }),
    setUnreadNot: (unread) => dispatch({ type: 'SET', unread }),
    fetchUnreadMsg: () => dispatch(countUnreadMessages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavbarBasic));
